module.exports = __webpack_public_path__ + "img/askPriceDesc2.7501f79d.png";